<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WkQuotesSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue',): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    quantity: 0
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

watch(() => form.value.settings, () =>
{
    triggerModel();
},
{ deep: true });

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({
            quantity: schema.number().min(1, $t('[[[Minimalna liczbna cytatów to 1]]]')).max(6, $t('[[[Maksymalna liczba cytatów to 6]]]'))
        })
    }));
}
onBeforeMount((): void =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});

defineExpose({
    validate
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Ilość wyświetlanych cytatów]]]')" :invalid-feedback="form.$errors.first('settings.quantity')" :state="form.$errors.state('settings.quantity')" required>
        <IdeoFormInput v-model="form.settings.quantity" type="number" :min="1" :max="6" />
    </IdeoFormGroup>
</template>
